import React from 'react';
import clsx from 'clsx';
import {
  InformationCircleIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon
} from '@heroicons/react/20/solid';

const alertStyles = {
  info: 'bg-blue-50 text-blue-900 dark:bg-blue-950 dark:text-blue-200 [&_svg]:text-blue-500',
  success: 'bg-emerald-50 text-emerald-900 dark:bg-emerald-950 dark:text-emerald-200 [&_svg]:text-emerald-500',
  warning: 'bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-200 [&_svg]:text-amber-500',
  error: 'bg-red-50 text-red-900 dark:bg-red-950 dark:text-red-200 [&_svg]:text-red-500'
};

const icons = {
  info: InformationCircleIcon,
  success: CheckCircleIcon,
  warning: ExclamationTriangleIcon,
  error: XCircleIcon
};

type AlertBannerProps = {
  type: 'info' | 'success' | 'warning' | 'error';
  heading?: string;
  children: React.ReactNode;
  className?: string;
};

export function AlertBanner({ type, heading, children, className }: AlertBannerProps) {
  const Icon = icons[type];
  return (
    <div className={clsx('rounded-lg p-4', alertStyles[type], className)} role="alert">
      <div className="flex gap-3">
        <Icon className="size-5 shrink-0 mt-0.5" />
        <div className="text-sm">
          {heading && <p className="font-semibold mb-1">{heading}</p>}
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
}
